import { useMutation, useQueryClient } from "@tanstack/react-query";

import { axiosInstance } from "../../lib/axios";

import { INTEGRATIONS_QUERY_KEY } from "./useFetchAllIntegrations";
import { CONNECTED_INTEGRATIONS_QUERY_KEY } from "./useFetchConnectedIntegration";

interface TelegramVerifyOtpRequest {
  phone_number: string;
  otp: number;
  password?: string;
}

interface TelegramVerifyOtpResponse {
  results: {
    name: string;
    verifiable_id: string;
    avatar: string | null;
    source: string;
    preferences: Array<{
      type: "contacts" | "groups";
      data: Array<{
        avatar: string | null;
        name: string;
        primary: string | number | null;
        type: "contact" | "group";
        source_id: number;
        sub_folder: string | null;
        status: boolean;
      }>;
    }>;
    verifiable_id_type: string;
  };
}

export const useTelegramVerifyOtp = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: TelegramVerifyOtpRequest) => {
      return await axiosInstance.post<TelegramVerifyOtpResponse>(
        "/connect/telegram/verify_otp",
        data,
      );
    },
    onSuccess: async () => {
      const promises = [
        queryClient.invalidateQueries({
          queryKey: INTEGRATIONS_QUERY_KEY(),
        }),
        queryClient.invalidateQueries({
          queryKey: CONNECTED_INTEGRATIONS_QUERY_KEY("telegram"),
        }),
      ];
      return Promise.all(promises);
    },
    onError: (error) => {
      console.error("Telegram OTP verification failed:", error);
    },
  });
};
